import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import Typing from 'react-typing-animation';
import BackgroundSlideshow from 'react-background-slideshow'
import { useTranslation } from 'react-i18next';

import image1 from './images/desk.jpg';
import image2 from './images/coffee1.jpg';
import image3 from './images/home-7-3-bg.jpg';


const Home7 = () => {
    
  
    const { t, i18n } = useTranslation()

    const changeLanguage = (event) => {
        i18n.changeLanguage(event.target.value)
    }
    

        return (
            <React.Fragment>
                <section className="home-7-bg back-slide" id="home">
                <div className="bg-overlay" style={{ zIndex : "1" }}></div>
                <BackgroundSlideshow  images={[ image1 ]} />
                  
                    <div className="home-center" id="contentSlider">
                        <div className="home-desc-center">
                            <div className="container">
                                <Row className="justify-content-center">
                                    <Col lg="8">
                                        <div className="mt-40 text-center home-5-content">
                                            
                                              <h1  className="text-white font-weight-light home-7-title mb-0"> <span className="element">{t('title.label')}</span></h1>
                                              
                                               
                                               
                                          
                                            <p className="text-white-70 font-weight-light mt-4 f-15 mb-0">{t('sub.label')}</p>
                                          
                                         
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                 
                </section>
            </React.Fragment>
        );
    
}
export default Home7;